// extracted by mini-css-extract-plugin
export default {"form":"reset-password_form__-Hyyk","btn":"reset-password_btn__BpsOF"};